(function ($) {
  class ProvinceFilter {
    /**
     * Constructor
     */
    constructor() {
      this.ajaxUrl = siteConfig?.ajaxUrl ?? "";
      this.ajaxNonce = siteConfig?.ajaxNonce ?? "";
      this.provinceSelect = $(".js-province-form");
      this.loadMoreBtn = $("#event-load-more");
      this.isLoading = false;
      this.loadMoreDiv = $("#post-pagination").data("max-pages");

      this.init();
    }

    init() {
      if (!this.provinceSelect.length) {
        return;
      }

      this.provinceSelect.on("change", (e) => {
        e.preventDefault();

        this.selectedProvince = this.provinceSelect
          .find(".js-filter-option:selected")
          .val();


        this.handleSelectFilter();
      });
    }

    handleSelectFilter() {
      $.ajax({
        url: this.ajaxUrl,
        type: "post",
        data: {
          province: this.selectedProvince,
          action: "events_load_more",
          ajax_nonce: this.ajaxNonce,
        },
        success: (res) => {
          $("#load-more-content").html(res);
          var loadMoreDiv = $("#post-pagination").data("max-pages");
          if (!loadMoreDiv) {
            this.loadMoreBtn.hide();
          }
        },
        error: (err) => {
          console.log(err);
        },
      });
    }
  }
  new ProvinceFilter();
})(jQuery);
